var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-report-table" },
    [
      _vm.loading
        ? _c("loader", {
            staticClass: "documents-report-table__loader",
            class: {
              cover: _vm.workers.length,
            },
            attrs: {
              active: _vm.loading,
              label: "Данные загружаются",
              height: "300",
            },
          })
        : _vm._e(),
      _vm.workers.length
        ? _c(
            "horizontal-table",
            {
              staticClass: "documents-report-table__table",
              attrs: { "fix-header": true },
              on: {
                nextPage: function ($event) {
                  return _vm.$emit("nextPage")
                },
              },
            },
            [
              _c(
                "table",
                { staticClass: "h-table", attrs: { "fix-header": true } },
                [
                  _c("tbody", [
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("ФИО")]),
                        _vm._l(_vm.workers, function (worker) {
                          return _c(
                            "td",
                            { key: worker.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "personal-employee-documents",
                                      params: { id: worker.id },
                                      query: { tab: "medical_documents" },
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(worker.name) + " ")]
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("Филиал")]),
                        _vm._l(_vm.workers, function (worker) {
                          return _c("td", { key: worker.id }, [
                            _vm._v(" " + _vm._s(worker.filial) + " "),
                          ])
                        }),
                      ],
                      2
                    ),
                    _c(
                      "tr",
                      [
                        _c("th", [_vm._v("Должность")]),
                        _vm._l(_vm.workers, function (worker) {
                          return _c(
                            "td",
                            { key: worker.id },
                            _vm._l(worker.positions, function (position) {
                              return _c("div", { key: position }, [
                                _vm._v(" " + _vm._s(position) + " "),
                              ])
                            }),
                            0
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._l(
                    _vm.filteredAnalyseGroups.filter(
                      (item) => item.analyses.length
                    ),
                    function (group) {
                      return [
                        _c(
                          "tr",
                          {
                            key: group.id + "-header",
                            staticClass: "documents-group",
                          },
                          [
                            _c("th", [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(" " + _vm._s(group.name) + " "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "b-toggle",
                                        rawName: "v-b-toggle",
                                        value: "group-toggler-" + group.id,
                                        expression:
                                          "'group-toggler-' + group.id",
                                      },
                                    ],
                                    staticClass: "toggler",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "toggler-icon",
                                      attrs: {
                                        name: "chevron-top-circled",
                                        size: 22,
                                        color: "primary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._l(_vm.workers, function (worker) {
                              return _c("td", { key: worker.id })
                            }),
                          ],
                          2
                        ),
                        _c(
                          "b-collapse",
                          {
                            key: group.id + "-items",
                            staticClass: "documents-group-items",
                            attrs: {
                              id: "group-toggler-" + group.id,
                              tag: "tbody",
                            },
                          },
                          _vm._l(group.analyses, function (analyse) {
                            return _c(
                              "tr",
                              {
                                key: group.id + "-analyse-" + analyse.id,
                                staticClass: "documents-item",
                              },
                              [
                                _c("th", [
                                  _c("span", [_vm._v(_vm._s(analyse.name))]),
                                ]),
                                _vm._l(_vm.workers, function (worker) {
                                  return _c("analyse-status", {
                                    key: worker.id,
                                    attrs: {
                                      worker: worker,
                                      "group-id": group.id,
                                      "analyse-id": analyse.id,
                                    },
                                  })
                                }),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    }
                  ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.inited && !_vm.loading && !_vm.workers.length
        ? _c("div", { staticClass: "documents-report-table__empty" }, [
            _vm._v(
              " Ничего не найдено. Попробуйте изменить параметры поиска. "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }